import React from "react";

export const Marquee = ({ items, accent = "gold" }) => {
  const tone = accent === "gold" ? "text-[var(--gold)]/70" : "text-[var(--cyan)]/70";
  return (
    <div className="no-scrollbar overflow-hidden border-y border-white/5 py-6 bg-black">
      <div className="marquee-track">
        {[...items, ...items].map((t, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className={`font-display text-2xl md:text-3xl tracking-tight text-white/85`}>{t}</span>
            <span className={`font-mono-tech text-xs ${tone}`}>◇</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
